// components/StreamingCursor.js - Shared streaming cursor component
import React from 'react';
import { Box } from '@chakra-ui/react';

export const StreamingCursor = () => (
    <Box
        as="span"
        display="inline-block"
        w="9px"
        h="18px"
        bg="#1c2eb5ff"
        ml={0}
        mr={2}
        mt={1}
        mb={1}
        verticalAlign="baseline"
        sx={{
            animation: 'streamingPulse 0.8s ease-in-out infinite',
            '@keyframes streamingPulse': {
                '0%, 100%': {
                    opacity: 0.4
                },
                '50%': {
                    opacity: 1
                }
            }
        }}
    />
);

export default StreamingCursor;